/* BLS collection navigation: functional chevron controls on desktop and mobile */
(() => {
  const selector = '.bls-cnav';
  const initialized = new WeakSet();

  function attach(nav) {
    if (initialized.has(nav)) return;
    initialized.add(nav);
    const rail = nav.querySelector('.bls-cnav__rail');
    const prev = nav.querySelector('[data-bls-nav="prev"]');
    const next = nav.querySelector('[data-bls-nav="next"]');
    if (!rail || !prev || !next) return;

    function update() {
      const canScroll = rail.scrollWidth > rail.clientWidth + 2;
      prev.disabled = !canScroll || rail.scrollLeft < 3;
      next.disabled = !canScroll || rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
      nav.classList.toggle('bls-cnav--static', !canScroll);
    }

    function advance(direction) {
      const cards = Array.from(rail.querySelectorAll('.bls-cnav__item'));
      if (cards.length < 2 || rail.scrollWidth <= rail.clientWidth + 2) return;
      const positions = cards.map(card => card.offsetLeft - cards[0].offsetLeft);
      const current = rail.scrollLeft;
      let target = direction > 0
        ? positions.find(position => position > current + 4)
        : positions.slice().reverse().find(position => position < current - 4);
      if (target === undefined) target = direction > 0 ? rail.scrollWidth : 0;
      rail.scrollTo({
        left: target,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }

    prev.addEventListener('click', () => advance(-1));
    next.addEventListener('click', () => advance(1));
    let frame = 0;
    rail.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = 0; update(); });
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    requestAnimationFrame(update);
  }

  function init(root = document) {
    root.querySelectorAll(selector).forEach(attach);
    if (root.matches?.(selector)) attach(root);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
